<template><span class="loading-spinner" aria-label="불러오는 중" /></template>
